import firebase from 'firebase'
import '@firebase/firestore'
// import '@firebase/auth'

let config = {
    apiKey: "AIzaSyDNazwSCrM5jp2ieYGQox1ABsz28Jkh8NA",
    authDomain: "yerd-ly-firebase.firebaseapp.com",
    databaseURL: "https://yerd-ly-firebase.firebaseio.com",
    projectId: "yerd-ly-firebase",
    storageBucket: "yerd-ly-firebase.appspot.com",
    messagingSenderId: "907855662856"
};
let fire = firebase.initializeApp(config);

export default fire;


// WEBPACK FOOTER //
// ./src/fire.js